import DeliveryReference from '@/generated/controls/delivery/DeliveryReference.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: DeliveryReference
})